import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { Icons } from "@learningblocks/exp-constants";
import styles from "./style.module.scss";
import { RichText } from "@learningblocks/shared-components/lib/RichText";

const {
  AlertLargeFail: AlertFail,
  AlertLargeSuccess: AlertSuccess,
  IncorrectRelative: CloseButton,
} = Icons;

export const FEEDBACK_SUCCESS = "SUCCESS";
export const FEEDBACK_FAIL = "FAIL";

export function QuestionFeedbackComponent({
  className = "",
  message = "Prediction Submitted!",
  onClose = null,
  type,
}) {
  const onCloseClick = (event) => onClose(event);

  const isSuccesss = () => type === FEEDBACK_SUCCESS;

  const getWrapperClass = () =>
    `${styles.feedback} ${
      isSuccesss() ? styles.success : styles.fail
    } ${className}`;

  const getFeedbackIcon = () =>
    isSuccesss() ? (
      <AlertSuccess className={styles.feedback_icon} />
    ) : (
      <AlertFail className={styles.feedback_icon} />
    );

  const renderCloseButton = () =>
    onClose ? (
      <CloseButton className={styles.feedback_close} onClick={onCloseClick} />
    ) : null;

  if (type && message) {
    const isPlainString = typeof message === "string";
    if (isPlainString) {
      const intl = useIntl();
      message = intl.formatMessage({
        id: message,
        defaultMessage: message,
      });
    }
    return (
      <div className={getWrapperClass()}>
        {getFeedbackIcon()}
        {isPlainString && <p className={styles.feedback_message}>{message}</p>}
        {!isPlainString && (
          <RichText
            {...{
              ...message,
              value: `${message}`,
            }}
          />
        )}
        {renderCloseButton()}
      </div>
    );
  } else return null;
}

QuestionFeedbackComponent.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(["SUCCESS", "FAIL", ""]),
  onClose: PropTypes.func,
  message: PropTypes.string,
};
